import { requestTemplate } from 'api';
import { IAttachment, IChat, IChatPayload } from 'interfaces';

type HistoryResponseType = {
  created_at: string;
  id: string;
  content: string;
  chat_id: string;
  author: {
    email: string;
    name: string;
    id: string;
  };
  status: string;
  replied_to: {
    id: string;
    content: string;
    created_at: string;
    author: {
      id: string;
      name: string;
      email: string;
    };
    status: string;
    attachment_ids: string[];
  } | null;
  attachment_ids: string[];
};


export type HistoryResponseV2Type = {
  messages: HistoryResponseType[];
  pagination:{
    pages:number;
    current:number;
    per_page:number;
    total:number;
  }
}

type GetChatHistoryV2Params = {
  chat_id: string;
  page?: number;
  per_page?: number;
  sort?: {
    field: string;
    direction: string;
  }[];
  filters?: any[];
}

const createChat = (payload: IChatPayload) => requestTemplate.post<IChat>('/chats/', payload);
const getRoomChats = (room_id: string, signal?: AbortSignal) =>
  requestTemplate.get<IChat[]>(`/chats/?room_id=${room_id}`, { signal: signal });
const getChatInfo = (chat_id: string) => requestTemplate.get<IChat>(`/chats/${chat_id}/`);
const getGLobalChats = () => requestTemplate.get<IChat[]>('/chats/global/chats/');
const getGLobalChatsV2 = () => requestTemplate.get<IChat[]>('/chats/global/chats/v2/');

const getChatHistory = (chat_id: string) =>
  requestTemplate.get<HistoryResponseType[]>(`/chats/message/?chat_id=${chat_id}`);

const getChatHistoryV2 = ({
  chat_id,
  page = 1,
  per_page = 20,
  sort = [{ field: 'created_at', direction: 'desc' }],
  filters = [],
}: GetChatHistoryV2Params) =>
  requestTemplate.get<HistoryResponseV2Type>(
    `/chats/message/v2/?chat_id=${chat_id}&page=${page}&per_page=${per_page}&sort=${JSON.stringify(
      sort
    )}&filters=${JSON.stringify(filters)}`
  );

const createGLobalChat = (formData: FormData) =>
  requestTemplate.post<IChat>(`/chats/global/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// Attachments
const uploadAttachment = (formData: FormData) =>
  requestTemplate.post<{ attachments: IAttachment[] }>(`/public/upload-attachment/`, formData, {
    headers: { Accept: 'application/json', 'Content-Type': 'multipart/form-data' },
  });
const getAttachment = (attachment_id: string) =>
  requestTemplate.get<Blob>(`/public/get-attachment/?_id=${attachment_id}`, { responseType: 'blob' });
const deleteAttachment = (attachment_id: string) =>
  requestTemplate.delete<IAttachment>(`/public/upload-attachment/?_id=${attachment_id}/`);

const deleteEmptyChat = (chat_id: string) =>
  requestTemplate.delete(`/chats/${chat_id}`);

const chats = {
  createChat,
  getRoomChats,
  getChatInfo,
  getChatHistory,
  getChatHistoryV2,
  getGLobalChats,
  getGLobalChatsV2,
  createGLobalChat,
  uploadAttachment,
  getAttachment,
  deleteAttachment,
  deleteEmptyChat
};

export default chats;
